import styled from 'styled-components';
import { TreeSelect } from 'antd';

export const CoreBrandsTreeSelector = styled(TreeSelect)`
  min-height: ${props => props.isEmpty ? '1.5rem' : '2rem'};
  display: flex;
  align-items: flex-start;

  & .ant-select-selector {
    display: flex;
    align-items: flex-start;
    min-height: ${props => props.isEmpty ? '1.5rem' : '2rem'};
    height: auto;
    padding-block: ${props => props.isEmpty ? '0' : '0.25rem'};
    padding-inline: 0.5rem;
    border: 1px solid rgba(0, 0, 0, 0.15) !important;
  }
  
  & .ant-select-selection-item {
    display: flex;
    align-items: center;
    line-height: normal;
    margin-block: 2px;
  }
  
  /* Target overflow item suffix with increased specificity */
  &.ant-select-multiple .ant-select-selection-overflow-item-suffix {
    margin-block: 0 ;
    min-height: 20px ;
  }
  
  & .ant-select-selection-overflow {
    min-height: ${props => props.isEmpty ? 'calc(1.5rem - 2px)' : 'calc(2rem - 2px)'};
    height: auto;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  & .ant-select-selection-wrap {
    display: flex;
    flex-wrap: wrap;
    min-height: ${props => props.isEmpty ? 'calc(1.5rem - 2px)' : 'calc(2rem - 2px)'};
    height: auto;
    align-items: flex-start;
  }

  & .ant-select-selection-item-content {
    padding-right: 4px;
  }
  
  & .ant-select-outlined {
    border: 1px solid rgba(0, 0, 0, 0.15);
  }
  
  /* Fix placeholder alignment when no items selected */
  & .ant-select-selection-placeholder {
    display: flex;
    align-items: center;
    height: ${props => props.isEmpty ? 'calc(1.5rem - 2px)' : 'calc(2rem - 2px)'};
    padding-left: 0.25rem;
  }
`;